export const PAGE_CONFIG = {
  name: 'CommonPermissionWrap',
  children: [
    {
      name: 'TrendingPostsVdieoWrapper',
      config: {
        queryKey: 'tab',
        defaultTab: 'video',
        titleEn: '',
        titleCn: '',
        condGameIds: [
          'ud785de246c51b057a6bddc368b085e3c',
          'uc28b505cf53638c4d8c19d9618f8e85f',
          'ub17d7ae320ae6915026a9cc9c140b688',
          'ucd8ec5018adf4c91c3ee08963b9fd44a',
          'uf81ea1e9f7b346edbd35fc02f7c0499b',
          'u84fef2ab99684444d8ed285e29cb87bb',
          'u582dec6f9e8399c6653942bf0a87b93c',
          'u48ce2227003b83c66bdbce342881620b',
          'u581bc723fc48b68af350290de03f458c',
          'u42f5424ffcc4c9200a600464f42ef738',
          'u5ecb323900b7171946bd5fa8026bf6c2',
          'u9d29dcaddc97083a36840d4a27fa8cb8',
          'ub19e26a0414b4797addd30ceef12cc2e',
          'u29c5646bda65b68f12c80bfbb17c8004',
          'udf23eaba4bf8171fb3f900853c0f9527',
          'u0034a59d2a72f12d12f7ef6e11cd087d',
          'uef5a3b6548a308b0ba4a343f714e63d5',
          'u565775a19b5b23dcc20f43170907d05d',
          'ua9e68733f0289662a30933262b9d2d0c',
          'uc7848145bd54ffcc88f41fc07519676d',
          'u48bbd3fe8938ddea615d673b1d44574a',
          'u97c4c6dc7f2451e6d6c1233a8217d626',
          'u1fe2ab3e72b0870f6f97a79dbcd982fc',
          'u1d8eb7408fbe92e055651de920569a56',
          'u09208c92411aa287a2b029d26c75a227',
          'u539cce0c886bb6e173cfec268a8a0e62',
          'u0473182df4f736786ea923a1a2987f04',
          'u2388c6aa03a6500ae803bae2990db07d',
          'u93320db3942b78b00bfb9c6dfe49d9c4',
          'ub680ef2eab99a4620b67bf3a485f6c89',
          'u9a2a891389a59207c87c09a745d1236d',
          'u927705a1c3c1b552fdfa5aebe0e36db7',
          'u295eeae9d7fdf726a4f1ead6976de0fa',
          'uc963db032d10dab527a8ecf3930e9879',
          'u0d6c60cbe27d08613353a16c23aded80',
          'ucc84b8e362d4ffb33c48313a4cae8ef7',
          'ud681dca741dec32f4a072b7804728af1',
          'uf58d5086f69084cd36b3104dc63922aa',
        ],
        tabs: [
          {
            key: 'video',
            nameEn: 'Trending Videos',
            nameCn: '热门视频',
            name: 'ZoneTrendingPublicationsAdapter',
            prNoticeMarquee: {
              textEn: '',
              textZh: '',
            },
            componentProps: {
              contentType: 'video',
              sourcePathname: '/marketing/MahjongSolitaire/TrendingPublications',
            },
            logConfig: {
              enabled: true,
              pageId: '909001',
              pageName: 'trendingPostsVdieo-video',
              extInfo: 'home-studio-trendingPostsVdieo-video',
              pagePath: '/TrendingPostsVdieo?tab=video',
            },
          },
          {
            key: 'posts',
            nameEn: 'Trending Posts',
            nameCn: '热门帖子',
            name: 'ZoneTrendingPublicationsAdapter',
            prNoticeMarquee: {
              textEn: '',
              textZh: '',
            },
            componentProps: {
              contentType: 'posts',
              sourcePathname: '/marketing/MahjongSolitaire/TrendingPublications',
            },
            logConfig: {
              enabled: true,
              pageId: '909002',
              pageName: 'trendingPostsVdieo-posts',
              extInfo: 'home-studio-trendingPostsVdieo-posts',
              pagePath: '/TrendingPostsVdieo?tab=posts',
            },
          },
        ],
      },
    },
  ],
};
